

















import Vue from 'vue'
import Vuex from 'vuex'
export default Vue.component('intro-section', {
  methods: {
    newGame: function () {
      this.$store.commit('switchView', 'main')
      this.$store.dispatch('nextScene')
    }
  }
})
